'use strict';

(function(window) {

  var jobFeeds = {

    // Get element and check if it exists, if not stop, if yes run function
    init: function() {
      const jobFeedsEl = document.getElementsByClassName('JobFeed');

      if (!jobFeedsEl.length) {
        return;
      }

      this.eachFeed(jobFeedsEl);
    },

    // Get each feeds data attributes and append element
    eachFeed: function(feeds) {
      for (let feed of feeds) {
        const jobFeedUrl = feed.dataset.feed;
        const jobFeedCount = feed.dataset.count ? Number(feed.dataset.count) : 5;
        const jobFeedAdd = feed.dataset.additional;
        const jobFeedAppend = feed.getElementsByClassName('JobFeed-append')[0];
        const jobFeedRss = feed.dataset.rss;

        if(!jobFeedRss) {
          this.requestFeed(jobFeedUrl, jobFeedCount, jobFeedAdd, jobFeedAppend);
        } else {
          this.requestRss(jobFeedUrl, jobFeedAppend);
        }
      };
    },

    // if using RSS feed
    requestRss: function(url, appendEl) {
      fetch(url)
        .then(response => response.text())
        .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
        .then(data => {
          const items = data.getElementsByTagName('item');
          for(let item of items) {
            const itemDate = item.getElementsByTagName('pubDate')[0].innerHTML;
            const itemLink = item.getElementsByTagName('link')[0].innerHTML;
            const itemTitle = item.getElementsByTagName('title')[0].innerHTML;

            var itemHtml = `<div class="JobFeed-item">
              <div class="JobFeed-content">
                <time class="JobFeed-itemTime">${itemDate}</time>
                <h3 class="JobFeed-itemTitle">
                  <a class="JobFeed-itemLink" href="${itemLink}">${itemTitle}</a>
                </h3>
              </div>
              <div class="JobFeed-icon JobFeed-iconRight">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20">
                  <path fill="#afafaf" d="M15.08 9.35l-4.223-4.043.934-.934L17.757 10l-5.965 5.627-.933-.934 4.222-4.043H2.55v-1.3" />
                </svg>
              </div>
            </div>`;

            appendEl.insertAdjacentHTML('beforeend', itemHtml);
          }
        });
    },

    // Fetch feed data and create html
    requestFeed: function(url, count, additional, appendEl) {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          // each item append
          for (let [index, item] of data.records.entries()) {
            const itemDate = item.pubDate;
            const itemLink = item.link;
            const itemTitle = item.title;
            const itemPrimaryLoc = item.primaryLocation;
            const itemSecondLocs = item.additionLocations ? item.additionLocations.split('|') : '';

            var itemHtml = `<div class="JobFeed-item">
              <div class="JobFeed-content">
                <time class="JobFeed-itemTime">${itemDate}</time>
                <h3 class="JobFeed-itemTitle">
                  <a class="JobFeed-itemLink" href="${itemLink}">${itemTitle}</a>
                </h3>
                <div class="JobFeed-itemLocation">
                  <div class="JobFeed-itemLocationLeft">
                    Primary Location:
                  </div>
                  <div class="JobFeed-itemLocationRight">
                    ${itemPrimaryLoc}
                  </div>
                </div>
                ${itemSecondLocs ? `<div class="JobFeed-itemLocation">
                  <div class="JobFeed-itemLocationLeft">
                    Other Locations:
                  </div>
                  <div class="JobFeed-itemLocationRight">
                    ${itemSecondLocs.map(loc => `${loc}`).join('<br>')}
                  </div>
                </div>` : ''}
              </div>
              <div class="JobFeed-icon JobFeed-iconRight">
                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20">
                  <path fill="#afafaf" d="M15.08 9.35l-4.223-4.043.934-.934L17.757 10l-5.965 5.627-.933-.934 4.222-4.043H2.55v-1.3" />
                </svg>
              </div>
            </div>`;

            appendEl.insertAdjacentHTML('beforeend', itemHtml);
            // display # items from data-count
            if (!(index < count - 1)) {
              break;
            }
          }
        }).catch(function() {
          // error handling
          appendEl.insertAdjacentHTML('beforeend', '<p style="color:red;">Feed error - check feed url</p>');
        })
    }
  };

  (function() {
    jobFeeds.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/jobs-feeds.js